import React, { useState } from "react";
import { AppBar, Box, Toolbar, Typography, Button } from "@mui/material";
import "./main.css";
import PData from "./PortfolioData";

const Portfolio = () => {
  const [data, setData] = useState(PData);
  const filterItem=(cateItem)=>{
    const updateItems = PData.filter((curElem)=>{
        return curElem.category === cateItem;
    });
    setData(updateItems);
  }
  return (
    <>
      <div className="portfolio_heading">
        <h2>Portfolio</h2>
        <h1>
          Check our <span>Portfolio</span>
        </h1>
      </div>

      <div className="portfolio">
        <div className="menu-Toolbar">
        <Button onClick={()=> filterItem('Web')}>Web Development</Button>
        <Button onClick={()=> filterItem('UI/UX')}>UI/UX Design</Button>
        <Button onClick={()=> filterItem('Graphic')}>Graphic Design</Button>
        <Button onClick={()=> filterItem('Shopify')}>Shopify</Button>
        <Button onClick={()=> filterItem('E-Commerce')}>E-Commerce</Button>
        <Button onClick={()=> setData(PData)}>All</Button>
        </div>
      </div>

      <div className="portfolio-items">
        {data.map((elem) => {
          const {id, image, name, category, description } = elem;
          return (
            <>
              <div className="p-items">
                <img src={image} alt="" className="items-img" />
                <div>
                  <p>Category: {category}</p>
                  <a href={id} target="_blank"> {name}</a>
                  <p>{description}</p>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default Portfolio;
